// components/project-details/FileUploader.js
import React, { useRef, useState } from 'react';
import styles from './ProjectDetails.module.css';

const FileUploader = ({ onFileUpload, uploading }) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      onFileUpload(files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      className={`${styles.uploadArea} ${isDragging ? styles.dragging : ''}`}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*"
        onChange={(e) => onFileUpload(e.target.files)}
        style={{ display: 'none' }}
        id="file-upload"
        disabled={uploading}
      />
      
      <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
        <div style={{ color: 'var(--Text-Secondary)' }}>
          {uploading ? (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              gap: 'var(--spacing-xs)' 
            }}>
              <div className={styles.spinner} style={{ width: '1.25rem', height: '1.25rem' }}></div>
              <span>Uploading...</span>
            </div>
          ) : (
            <>
              <svg 
                className={styles.uploadIcon} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={1.5} 
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" 
                />
              </svg>
              <p className={styles.uploadText}>Click to upload or drag and drop</p>
              <p className={styles.uploadSubtext}>PNG, JPG, GIF up to 10MB</p>
            </>
          )}
        </div>
      </label>
    </div>
  );
};

export default FileUploader;